import { useEffect } from 'react';
import { useAuthStore } from '../store/auth-store';
import { useSchermataDiPartitaStore } from '../store/schermata-di-partita-store';

/**
 * «Analizza partita», dal lato di chi lo offre: la revisione partita.
 *
 * Due condizioni, e nessuna delle due riguarda DI CHI e' la partita che si sta
 * rivedendo (era il difetto: il bottone dipendeva da chi montava la review, e
 * quindi mancava nei tornei, nelle arene e nel profilo aperto in overlay):
 *
 *  1. un conto registrato — l'analisi salva in libreria, e la libreria e' del
 *     conto;
 *  2. nessuna schermata di partita montata sotto. L'analisi riscrive
 *     `game-store` (`startLocalGameFromBoard`) e NON naviga: aprirla sopra una
 *     damiera che sta ancora leggendo quello store le cambierebbe i pezzi sotto
 *     il naso. Vale anche a partita finita — il riepilogo e' ancora a schermo —
 *     e il perche' sta in `laSchermataUsaLoStoreDiPartita`
 *     (utils/partita-in-corso.ts).
 *
 * ⚠️ Solo selettori reattivi, mai `.getState()`: i test dei componenti che
 * ospitano la review mockano gli store *per selettore* e non espongono
 * `getState`. Ed e' anche l'unico modo per cui il bottone SPARISCE quando le
 * condizioni cambiano mentre la review e' aperta.
 */
export function usePuoAnalizzare(): boolean {
  const registrato = useAuthStore((s) => s.isAuthenticated && !s.isGuest);
  const schermataDiPartita = useSchermataDiPartitaStore((s) => s.montata);
  return registrato && !schermataDiPartita;
}

/**
 * …e lo stesso dal lato di chi lo sa: App.
 *
 * Pubblica il solo fatto che la revisione non puo' leggere da se'. Non naviga —
 * l'analisi si apre SOPRA la revisione, come un pannello qualunque — quindi qui
 * non c'e' niente da coordinare con la cronologia: il ballo in due tempi che
 * questo hook aveva (chiudi gli overlay, aspetta i riavvolgimenti, poi cambia
 * schermata) se n'e' andato col passaggio all'editor.
 *
 * @param montata  `laSchermataUsaLoStoreDiPartita(screen)`.
 */
export function usePubblicaSchermataDiPartita(montata: boolean): void {
  useEffect(() => {
    useSchermataDiPartitaStore.getState().setMontata(montata);
  }, [montata]);
}
